import { Stack } from '@mui/material';
import { TextInput, required } from 'react-admin';
import { useWatch } from 'react-hook-form';
import {
    useAccountDuplicateCheck,
    DuplicateWarning,
} from '../misc/DuplicateWarning';

export const AccountInputs = () => {
    const name = useWatch({ name: 'name' }) || '';
    const duplicateMatches = useAccountDuplicateCheck(name);

    return (
        <Stack gap={2} p={1}>
            <TextInput
                source="name"
                validate={required()}
                helperText={false}
                fullWidth
            />
            <DuplicateWarning matches={duplicateMatches} entityType="account" />
        </Stack>
    );
};
